import { SyncOutlined } from '@ant-design/icons';
import { t } from '@hefe/i18n';
import { BasketballPracticesSlice } from '@hefe/store';
import { Button, Popconfirm } from 'antd';
import { useState } from 'react';
import { useAppDispatch } from '../../../../store/store';

export default function SyncPracticesButton() {
  const dispatch = useAppDispatch();

  const [syncingPractices, setSyncingPractices] = useState(false);

  const syncPractices = () => {
    setSyncingPractices(true);
    dispatch(BasketballPracticesSlice.syncBasketballPractices())
      .unwrap()
      .catch(() => {})
      .finally(() => setSyncingPractices(false));
  };

  return (
    <Popconfirm
      title={t('practices.sync.info')}
      overlayStyle={{ width: 300 }}
      onConfirm={() => syncPractices()}
      okButtonProps={{ loading: syncingPractices }}
    >
      <Button type="primary" icon={<SyncOutlined />} loading={syncingPractices}>
        {t('practices.sync.title')}
      </Button>
    </Popconfirm>
  );
}
